import { render, staticRenderFns } from "./StockLending.vue?vue&type=template&id=b0bc5aa4&scoped=true"
import script from "./StockLending.vue?vue&type=script&lang=ts"
export * from "./StockLending.vue?vue&type=script&lang=ts"
import style0 from "./StockLending.vue?vue&type=style&index=0&id=b0bc5aa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bc5aa4",
  null
  
)

export default component.exports